// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page Catalogue acheteur : taille + onglets CALQUES sur les pages listes (Operation / Annuaire).
   Conteneur pleine largeur (le shell MainLayout gere le gutter) ; les onglets viennent de TabNav ;
   la grille de lots reutilise .accueil-lots-mosaic / .accueil-lot-card* (Accueil.css). */

.catalogue-page {
  width: 100%;
  padding: 0;
}

/* Espacement sous la barre d'onglets, comme .commandes-page .tab-nav (Operation). */
.catalogue-page .tab-nav {
  margin-bottom: 3rem;
}

/* Barre de filtres calquee sur Annuaire (.annuaire-filters / .filter-dropdown) : rangee flex de
   blocs "label + champ natif". Le style des <select>/<input> vient du global App.css. */
.catalogue-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 0 0 1.5rem;
  padding: 1rem 0;
}

.catalogue-filter {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  flex: 1 1;
}

.catalogue-filter label {
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #606060;
}

/* <input> et <select> ne calculent pas leur taille intrinseque a l'identique selon le UA : le champ
   Prestation (input) tombait un peu plus petit / decale par rapport aux selects. On fige une hauteur
   commune (border-box) -> input = select = bouton, alignes au pixel. */
.catalogue-filter select,
.catalogue-filter input {
  height: 4rem;
}

/* Colonnes "action" (Nouveau BC / Nouveau MS) : la colonne se reduit a la largeur du bouton (pas de
   colonne flexible), le bouton est aligne en bas -> au niveau des champs, pas des labels. */
.catalogue-filter--action {
  flex: 0 0 auto;
  min-width: auto;
  justify-content: flex-end;
}

/* Bouton d'action : largeur de son contenu (pas d'etirement, on neutralise \`align-self: stretch\`) et
   EXACTEMENT la meme hauteur figee que les champs (4rem, border-box). Le contenu (icone + texte) est
   centre par le \`.button\` (inline-flex). Selecteur plus specifique que \`.button.small\`. */
.catalogue-filters .catalogue-filter--action .button {
  align-self: flex-start;
  height: 4rem;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 12px;
  line-height: normal;
  border: 1px solid transparent;
  white-space: nowrap;
}

/* L'icone "+" par defaut (20px) depasse la ligne de texte (12px) et rendrait le bouton plus haut que
   l'input : on la ramene sous la ligne de texte pour qu'elle ne dicte plus la hauteur. */
.catalogue-filters .catalogue-filter--action .button .button-icon svg {
  width: 1.2rem;
  height: 1.2rem;
}

.catalogue-filter select:focus,
.catalogue-filter input:focus {
  border-color: #f97316;
  outline: none;
}

@media screen and (max-width: 768px) {
  .catalogue-filters {
    flex-direction: column;
  }
  .catalogue-filter {
    width: 100%;
  }
}

.catalogue-empty {
  color: #6b7280;
  font-size: 1.5rem;
  text-align: center;
  padding: 4rem 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Catalogue/Catalogue.css"],"names":[],"mappings":"AAAA;;yFAEyF;;AAEzF;EACE,WAAW;EACX,UAAU;AACZ;;AAEA,oFAAoF;AACpF;EACE,mBAAmB;AACrB;;AAEA;wFACwF;AACxF;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;uEAEuE;AACvE;;EAEE,YAAY;AACd;;AAEA;4FAC4F;AAC5F;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;0FAE0F;AAC1F;EACE,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;yFACyF;AACzF;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["/* Page Catalogue acheteur : taille + onglets CALQUES sur les pages listes (Operation / Annuaire).\n   Conteneur pleine largeur (le shell MainLayout gere le gutter) ; les onglets viennent de TabNav ;\n   la grille de lots reutilise .accueil-lots-mosaic / .accueil-lot-card* (Accueil.css). */\n\n.catalogue-page {\n  width: 100%;\n  padding: 0;\n}\n\n/* Espacement sous la barre d'onglets, comme .commandes-page .tab-nav (Operation). */\n.catalogue-page .tab-nav {\n  margin-bottom: 3rem;\n}\n\n/* Barre de filtres calquee sur Annuaire (.annuaire-filters / .filter-dropdown) : rangee flex de\n   blocs \"label + champ natif\". Le style des <select>/<input> vient du global App.css. */\n.catalogue-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin: 0 0 1.5rem;\n  padding: 1rem 0;\n}\n\n.catalogue-filter {\n  display: flex;\n  flex-direction: column;\n  min-width: 200px;\n  flex: 1;\n}\n\n.catalogue-filter label {\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #606060;\n}\n\n/* <input> et <select> ne calculent pas leur taille intrinseque a l'identique selon le UA : le champ\n   Prestation (input) tombait un peu plus petit / decale par rapport aux selects. On fige une hauteur\n   commune (border-box) -> input = select = bouton, alignes au pixel. */\n.catalogue-filter select,\n.catalogue-filter input {\n  height: 4rem;\n}\n\n/* Colonnes \"action\" (Nouveau BC / Nouveau MS) : la colonne se reduit a la largeur du bouton (pas de\n   colonne flexible), le bouton est aligne en bas -> au niveau des champs, pas des labels. */\n.catalogue-filter--action {\n  flex: 0 0 auto;\n  min-width: auto;\n  justify-content: flex-end;\n}\n\n/* Bouton d'action : largeur de son contenu (pas d'etirement, on neutralise `align-self: stretch`) et\n   EXACTEMENT la meme hauteur figee que les champs (4rem, border-box). Le contenu (icone + texte) est\n   centre par le `.button` (inline-flex). Selecteur plus specifique que `.button.small`. */\n.catalogue-filters .catalogue-filter--action .button {\n  align-self: flex-start;\n  height: 4rem;\n  padding-top: 0;\n  padding-bottom: 0;\n  font-size: 12px;\n  line-height: normal;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n/* L'icone \"+\" par defaut (20px) depasse la ligne de texte (12px) et rendrait le bouton plus haut que\n   l'input : on la ramene sous la ligne de texte pour qu'elle ne dicte plus la hauteur. */\n.catalogue-filters .catalogue-filter--action .button .button-icon svg {\n  width: 1.2rem;\n  height: 1.2rem;\n}\n\n.catalogue-filter select:focus,\n.catalogue-filter input:focus {\n  border-color: #f97316;\n  outline: none;\n}\n\n@media screen and (max-width: 768px) {\n  .catalogue-filters {\n    flex-direction: column;\n  }\n  .catalogue-filter {\n    width: 100%;\n  }\n}\n\n.catalogue-empty {\n  color: #6b7280;\n  font-size: 1.5rem;\n  text-align: center;\n  padding: 4rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
